import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';

import { RouterLink } from '@angular/router';
import { PageTitleService } from '../../core/services/page-title.service';
import { NotificationService } from '../../core/services/notification.service';
import { MemberApiService } from '../../core/services/member-api.service';

@Component({
    selector: 'app-notification',
    imports: [RouterLink],
    templateUrl: './notification.component.html'
})
export class NotificationComponent implements OnInit {
  private pageTitle = inject(PageTitleService);
  private notificationService = inject(NotificationService);
  private memberApi = inject(MemberApiService);

  notification: { plan?: any; payment?: any } = {};
  member: any = {};

  async ngOnInit(): Promise<void> {
    this.pageTitle.set('fa s-icon-list', '諸届');
    const [data, member] = await Promise.all([
      this.notificationService.get(),
      this.memberApi.getOne('self'),
    ]);
    this.member = member ?? {};
    if (Array.isArray(data) && data.length > 0) {
      const now = new JstDate();
      this.notification.plan = data.find(v =>
        v.requestType === 3 && (v.status === 0 || v.status === 1 || (v.status === 2 && new JstDate(v.startDate) > now))
      );
      this.notification.payment = data.find(v =>
        v.requestType === 6 && (v.status === 0 || v.status === 1 || (v.status === 2 && new JstDate(v.startDate) > now))
      );
    }
  }

  formatDate(dateStr: string, format: string): string {
    if (!dateStr) return '';
    const d = new JstDate(dateStr);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return format.replace('yyyy', String(y)).replace('MM', m).replace('dd', day);
  }
}
